import { useMemo } from 'react';
import type React from 'react';
import type { PropsWithChildren } from 'react';

import st from './PageSection.module.sass';

interface PageSectionProps extends PropsWithChildren {
  title: string;
  actions?: React.ReactNode;
}

function PageSection({
  title,
  actions = undefined,
  children = undefined,
}: PageSectionProps): React.JSX.Element {
  const $subheading = useMemo(() => {
    const $title = (
      <h5 className={st.Title}>
        {title}
      </h5>
    );
    if (!actions) return $title;

    return (
      <div className={st.Subheading}>
        {$title}
        {!!actions && actions}
      </div>
    );
  }, [title, actions]);
  return (
    <div className={st.PageSection}>
      {$subheading}
      {children}
    </div>
  );
}

export { PageSection };
